import { DataSource } from '@tlbs/galaxy-sdk';
let instance: null | LooseObject = null;
let dataSource1: null | LooseObject = null;
let dataSource2: null | LooseObject = null;
export default class BaseService {
  constructor() {
    this.setDomain({ baseMapDomain: '', baseServiceDomain: '' });
  }

  public setDomain(baseDomain: ({ baseMapDomain: string, baseServiceDomain: string })) {
    dataSource1 = new DataSource({
      baseURL: baseDomain?.baseMapDomain || 'https://testservice.wemap.qq.com/base/map',
      withCredentials: true,
    });
    dataSource2 = new DataSource({
      baseURL: baseDomain?.baseServiceDomain || 'https://testservice.wemap.qq.com',
      withCredentials: true,
    });
  }

  public getDomain() {
    return { dataSource1, dataSource2 };
  }
  public getMapLayerList(mapId: string | number) {
    const headers = {
      BuilderKey: '',
    };
    if (mapId === 'bf55fbd6-83e8-4875-986d-904a4d667e47') { // 针对公有数据做特殊处理
      headers.BuilderKey = 'K73J7-OHRQ7-GPFS3-ZV5W5-OVTV5-RZSPU';
    }
    return dataSource1?.request({
      url: 'mapmanager/api/likeQueryLayer',
      method: 'get',
      headers,
      params: {
        mapId,
      },
    });
  }

  public getMapDetail(id: string | number) {
    return dataSource1?.request({
      url: 'mapmanager/api/queryMap',
      method: 'get',
      params: {
        id,
      },
    });
  }

  public getWFSData(id: string | number) {
    return dataSource1?.request({
      url: 'webmap/data/thirdregister/api/getwfsdata',
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: {
        id,
      },
    });
  }

  public getFeatureServerData(id: string | number) {
    return dataSource1?.request({
      url: 'webmap/data/thirdregister/api/getfeatureserverdata',
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: {
        id,
      },
    });
  }

  public getThirdGeoJSONThinning(id: string | number) {
    return dataSource1?.request({
      url: 'webmap/data/thirdregister/api/getfeatureserverdata',
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: {
        id,
      },
    });
  }

  public getServiceInfo(ids: string | number) {
    return dataSource2?.request({
      url: 'base/data/service/api/getserviceinfo',
      method: 'get',
      params: {
        ids,
      },
    });
  }

  public getTifServiceInfo(ids: string | number) {
    return dataSource2?.request({
      url: 'webmap/geotiff/api/tifinfoview',
      method: 'get',
      params: {
        ids,
      },
    });
  }
}

export function getInstance() {
  if (instance === null) {
    instance = new BaseService();
  }
  return instance;
}
